// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"TourVideo_fadeIn__1-rem","playerWrapper":"TourVideo_playerWrapper__3g1t4"};